// Generated by CoffeeScript 1.12.1
(function() {
  var Srv, _;

  _ = {
    get: require('lodash/get'),
    map: require('lodash/map'),
    split: require('lodash/split'),
    trimEnd: require('lodash/trimEnd')
  };

  Srv = (function() {
    function Srv() {}

    Srv.ENODATA = function(arg) {
      var body, error;
      body = arg.body;
      error = new Error();
      error.code = 'ENODATA';
      error.errno = 'ENODATA';
      error.syscall = 'querySrv';
      error.hostname = _.trimEnd(_.get(body, 'Question.0.name'), '.');
      error.message = error.syscall + " " + error.errno + " " + error.hostname;
      return error;
    };

    Srv.parseResult = function(result, callback) {
      var body, error, records;
      if (!result.ok) {
        return callback(new Error("Unexpected error: " + result.body));
      }
      try {
        body = JSON.parse(result.text);
      } catch (error1) {
        error = error1;
        return callback(error);
      }
      records = _.get(body, 'Answer');
      if (records == null) {
        return callback(Srv.ENODATA({
          body: body
        }));
      }
      return callback(null, _.map(records, Srv.parseRecord));
    };

    Srv.parseRecord = function(record) {
      var name, port, priority, ref, weight;
      ref = _.split(record.data, ' '), priority = ref[0], weight = ref[1], port = ref[2], name = ref[3];
      return {
        ttl: record.TTL,
        address: {
          name: _.trimEnd(name, '.'),
          priority: parseInt(priority),
          weight: parseInt(weight),
          port: parseInt(port)
        }
      };
    };

    return Srv;

  })();

  module.exports = Srv;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/http-dns/dist/srv.js
// module id = 69
// module chunks = 0